import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { Button, Form, Input, Spin } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';

const Login = (props) => {
  const { onChangeUsername, onChangePassword, onSubmit, setTenantId } = props;
  const { username, password, loggingIn, authenticated, tenants } = props;
  const location = useLocation();
  const params = useParams();

  const tenantId = (tenants || []).includes(params.tenantId) ? params.tenantId : '';

  if (authenticated) {
    setTenantId(tenantId);
    return <Navigate to={{ pathname: `/${tenantId}`, state: location.state }} />;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundImage: 'url(img/vizor-background.png)',
        height: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          fontSize: 30,
          margin: '50px 0px',
        }}
      >
        <img
          alt=""
          src="img/vizor-logo-103x122.png"
          height="122"
          width="103"
          style={{ marginRight: 5 }}
        />
        <div style={{ color: 'rgb(255, 255, 255)' }}>Vizor Analytics</div>
      </div>
      <div>
        <Spin spinning={!!loggingIn} size="large">
          <div
            style={{
              backgroundColor: 'rgb(255, 255, 255)',
              padding: 25,
              border: '5px solid rgb(247, 246, 244)',
            }}
          >
            <Form onFinish={onSubmit} className="login__form">
              <Form.Item>
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Username"
                  value={username}
                  onChange={(e) => onChangeUsername(e.target.value)}
                  className="login__form_user"
                  name="username"
                />
              </Form.Item>
              <Form.Item>
                <Input
                  prefix={<LockOutlined />}
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => onChangePassword(e.target.value)}
                  className="login__form_password"
                  name="password"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  style={{ width: '100%' }}
                >
                  Sign in
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default Login;
